import React from 'react'
import TestTakingSkills from './TestTakingSkills'

export default function TestTakingSummary({testTakingData}) {
  return (
    <section className='TestTakingSkills'>
      <h3 className="Title">Test-Taking Skills</h3>
      <TestTakingSkills testTakingData={testTakingData} />
    </section>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/Overview/TestTakingSummary.js